import $ from 'jquery'
import styleSelect from 'styleselect'
import lity from 'lity'
import Cookies from 'js-cookie'
var sticky = require('jquery-sticky')

$(function () {
	var CPLX = {
		vars: {
			zip: false,
			lb: false,
			doc: {
				width: 0,
				height: 0,
				isMobile: true,
			},
		},
		methods: {
			backToTopCalc: function () {
				var scrollHeight = $(document).height()
				var scrollPosition = $(window).height() + $(window).scrollTop()
				var scrollTop = $(window).scrollTop()
				if (scrollTop > 100) {
					$('.btp').addClass('show')
				} else {
					$('.btp').removeClass('show')
				}
			},
			backToTop: function () {
				$('html,body').animate(
					{
						scrollTop: 0,
					},
					700
				)
			},
			changeBrand: function (brand, zip) {
				// for empire changeout
				if (CPLX.vars.lb) {
					CPLX.vars.lb.close()
				}
				$('.zipBar__zip').html(zip)
				if (brand == 'EBC') {
					// adjust logo
					$('.logo, .nav__mobileNavLogo').attr(
						'src',
						'/assets/img/logo-empire-bc.svg'
					)
					$('.legal__empireBCBS').hide()
					$('.legal__empireBC').show()
					if ($('.student__healthcare101video')) {
						$('.healthcare101__ebcbs').hide()
						$('.healthcare101__ebcbs').show()
					}
				} else {
					$('.logo, .nav__mobileNavLogo').attr(
						'src',
						'/assets/img/logo-empire-bcbs.svg'
					)
					$('.legal__empireBCBS').show()
					$('.legal__empireBC').hide()
					if ($('.student__healthcare101video')) {
						$('.healthcare101__ebcbs').show()
						$('.healthcare101__ebcbs').hide()
					}
				}
			},
			storeSize: function () {
				CPLX.vars.doc = {
					width: $(window).width(),
					height: $(window).height(),
				}
				if (CPLX.vars.doc.width <= 992) {
					CPLX.vars.doc.isMobile = true
				} else {
					CPLX.vars.doc.isMobile = false
				}
			},
			runSticky: function () {
				$('nav.nav').first().sticky()
			},
			openModal: function () {
				return
				var data = $('.zipBar__modal')[0].outerHTML
				CPLX.vars.lb = lity(data)
			},
			initEmpire: function () {
				
				$('body')
					.children()
					.each(function () {
						//console.log($(this))
						if (
							$(this).hasClass('school--picker') ||
							$(this).hasClass('school--detail')
						) {
							return
						}
						$(this).html(
							$(this)
								.html()
								.replace(
									'Anthem Student Advantage',
									'Empire Student Advantage'
								)
						)
						$(this).html($(this).html().replace('Anthem', 'Empire'))
						//$('nav.nav').first().unstick()
						//$('nav.nav').first().sticky()
					})
			},
			init: function () {
				this.storeSize()
				//setTimeout(function(){ this.runSticky() }, 1000)
			},
		},
	}

	CPLX.methods.init()

	$(window).on('resize', CPLX.methods.storeSize)

	$(window).on('scroll', function () {
		CPLX.methods.backToTopCalc()
	})

	$('.btp').on('click', function () {
		CPLX.methods.backToTop()
	})

	setTimeout(function () {
		$('select').each(function () {
			styleSelect(this)
		})
	}, 1000)

	$('.nav__mobileMenu').on('click', function () {
		$('.nav__mobileNav').toggleClass('active')
	})

	$('.nav__mobileListClose').on('click', function () {
		$('.nav__mobileNav').removeClass('active')
	})

	$('body').on('click', '.accordion h3', function () {
		$(this).parent().toggleClass('active')
		$(this).siblings('.accordion__list').slideToggle()
	})

	$('body').on('click', '.zipBar__trigger', function () {
		CPLX.methods.openModal()
	})

	$(document).on('lity:close', function (event, instance) {
		if (!CPLX.vars.zip) {
			var data = $('.zipBar__modal')[0].outerHTML
			CPLX.vars.lb = lity(data)
		}
	})

	$('body').on('click', '.zipBar__notNY', function () {
		Cookies.set('zip', 'Outside NY')
		Cookies.set('brand', 'EBC')
		CPLX.methods.changeBrand('EBC', 'Outside NY')
		CPLX.vars.lb.close()
	})

	$('body').on('click', '.zipBar__submit', function () {
		var zip = $(this).siblings('.zipBar__zipInput').val()
		$.ajax({
			method: 'POST',
			url: '/ep/loader/zip',
			data: { zip: zip },
		})
			.done(function (v) {
				if (v.status == 200) {
					Cookies.set('zip', zip)
					Cookies.set('brand', v.brand)
					CPLX.vars.zip = zip
					CPLX.methods.changeBrand(v.brand, zip)
				} else {
					$('.zipBar__error').show()
				}
			})
			.fail(function () {})
	})

	$('.changeAdmin').on('click', function (e) {
		e.preventDefault()
		Cookies.set('studentAdvType', 'admin', { domain: 'anthem.com' })
		window.location.href = '/'
	})

	$('.changeStudent').on('click', function (e) {
		e.preventDefault()
		Cookies.set('studentAdvType', 'student', { domain: 'anthem.com' })
		window.location.href = '/'
	})

	

	$('.appLink').on('click', function (e) {
		e.stopPropagation()
		var id = 'apps'
		var p = $(this).parents('.school__pill')
		if (CPLX.vars.doc.isMobile) {
			$('.school__pillMobileData').hide()
			$('.school__pillItem').removeClass('active')
			$('.school__pillItem[data-id="apps"] .school__pillMobileData')
				.show()
				.addClass('active')
			//$('.school__pillItem[data-id="apps"]').addClass('active')
		} else {
			$('.school__placeholder').hide()
			if ($(p).hasClass('disable')) {
				return
			}
			var sibs = $(p).find('.school__pillItem, .school__pillData')
			$(sibs).removeClass('active')
			$('.school__pillItem[data-id="apps"]').addClass('active')
			$(p)
				.find('.school__pillData[data-id="' + id + '"]')
				.addClass('active')
		}
	})

	$('#schoolPick').on('change', function () {
		let url = $(this).val()
		window.location.href = '/student/schools/' + url
	})

	$('.picker__submit').on('click', function () {
		//var type = $('input[type=radio]:checked').val()
		var type = 'student'
		var state = $('#state').val()
		var url = ''
		var app = ''
		//console.log('booga', type, state)
		if (!type || !state) {
			$('.picker__error').show()
			return
		}

		if (state == 'NY') {
			url = 'https://student.empireblue.com'
			Cookies.set('studentAdvType', type, { domain: 'empireblue.com' })
			Cookies.set('studentAdvState', state, { domain: 'empireblue.com' })
			if (type == 'student') {
				app = '/student'
			}
			url = url + app
			window.location.href = url
			return
		} else if (state == 'CA') {
			url = 'https://studentca.anthem.com'
		} else {
			url = 'https://student.anthem.com'
		}

		

		if (state !== 'NY') {
			Cookies.set('studentAdvType', type, { domain: 'anthem.com' })
			Cookies.set('studentAdvState', state, { domain: 'anthem.com' })
			if (type == 'student') {
				app = '/student'
			}
			
			//url = url + app
		}

		url = url + app
		window.location.href = url
	})

	$('.picker__utah').on('click', function () {
		var type = $('input[type=radio]:checked').val()
		var url
		if (!type) {
			$('.picker__error').show()
			return
		}

		if(type == 'student') {
			url = 'https://student.anthem.com/student/schools/usu'
		}
		else {
			url = 'https://student.anthem.com/'
		}

		Cookies.set('studentAdvType', type, { domain: 'anthem.com' })
		window.location.href = url
	})

	$('.picker__school #state').on('change', function () {
		var state = $('#state').val()
	})

	if ($('.student__healthcare101video')) {
	}

	// If empire, run zip code
	if (
		window.location.hostname.indexOf('empireblue') !== -1 &&
		window.location.pathname !== '/welcome'
	) {
		// On Empire
		CPLX.methods.initEmpire()
	}

	$('.school__pillItem')
		//.not('.school__pillItem--enroll')
		.on('click', function () {
			var id = $(this).attr('data-id')
			var p = $(this).parents('.school__pill')
			if (CPLX.vars.doc.isMobile) {
				$('.school__pillMobileData').hide()
				$('.school__pillItem').removeClass('active')
				$('.school__pillMobileData', this).show().addClass('active')
				$(this).addClass('active')
			} else {
				$('.school__placeholder').hide()
				if ($(p).hasClass('disable')) {
					return
				}
				var sibs = $(p).find('.school__pillItem, .school__pillData')
				$(sibs).removeClass('active')
				$(this).addClass('active')
				$(p)
					.find('.school__pillData[data-id="' + id + '"]')
					.addClass('active')
			}
		})

	// Enroll pill breakout for some schools
	if($('.school__enrollList').length > 0) {
		$('.school__pillItem--enroll').on('click', function() {
			$('.school__pillNavList--enroll').hide()
			$('.school__enrollSubMenu').show();
			$('.school__close').show()
			$('.school__pill--enroll .school__pillData').removeClass('active')
		})
		$('.school__enrollSubMenu > li').first().on('click', function() {
			let el = $(this)[0]
			let id = $(el).attr('data-id')
			$('.school__pillData[data-id="' + id + '"]').show()
			
		})
		$('.school__close').on('click', function() {
			$('.school__pillNavList--enroll').show()
			$('.school__pillNavList--enroll .school__pillItem--enroll').removeClass('active')
			$('.school__enrollSubMenu').hide()
			$('.school__pill--enroll .school__pillData').removeClass('active')
			$(this).hide()
		})
	}
})
